import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { infoItems, navItems, socialItems } from "../mock/Header";

const Header = () => (
  <header>
    <div className="header-top">
      <div className="container">
        <div className="row">
          <div className="col-xl-8 text-center">
            <ul className="list-unstyled d-block d-sm-flex align-items-center gap-3 pt-3">
              {infoItems.map(({ icon, text, link }, index) => (
                <li key={index}>
                  <FontAwesomeIcon
                    icon={icon}
                    style={{ marginRight: "10px" }}
                  />
                  {link ? (
                    <NavLink to="" className="site-ancer">
                      {text}
                    </NavLink>
                  ) : (
                    text
                  )}
                </li>
              ))}
            </ul>
          </div>
          <div className="col-xl-4 text-center">
            <ul className="list-unstyled d-block d-sm-flex align-items-center justify-content-end gap-3 pt-3">
              {socialItems.map(
                ({ icon, path, hide }, index) =>
                  !hide && (
                    <li key={index}>
                      <NavLink to={path} className="site-ancer">
                        <FontAwesomeIcon icon={icon} />
                      </NavLink>
                    </li>
                  )
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
    <hr className="my-2" />
    <div className="header-main">
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <NavLink className="navbar-brand site-ancer" to="/">
            <img src="images/logo.png" alt="Logo" />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0 m-auto text-uppercase">
              {navItems.map(({ path, label }, index) => (
                <li className="nav-item" key={index}>
                  <NavLink
                    className="nav-link site_nav_links"
                    to={path}
                    aria-current="page"
                  >
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
            <NavLink to="/login" className="site-ancer text-uppercase px-3">
              Login
            </NavLink>
            <NavLink to="/register" className="site-ancer text-uppercase mx-1">
              Register
            </NavLink>
          </div>
        </div>
      </nav>
    </div>
  </header>
);

export default Header;
